<template>
  <ul class="plain-unordered-list">
    <li v-for="(item, index) in items"
        :key="index">{{item}}</li>
  </ul>
</template>

<script>
export default {
  name: 'PlainUnorderedList',
  props: {
    items: {
      type: Array,
    },
  },
};
</script>
